class CartDrawer extends HTMLElement {
  constructor() {
    super()
    this.container =  this.querySelector('#cart-drawer-container')
    this.cartButton = document.querySelector('#cart-button')

    this.container.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault()
        this.open()
      }
    })
    this.cartButton.addEventListener('click', () => this.open())
    document.body.addEventListener('keydown', (evt) => evt.code === 'Escape' && this.close())

    this.init()
  }

  init() {
    this.overlay = this.querySelector('#cart-drawer-overlay')
    this.contents = this.querySelector('#cart-drawer-contents')
    this.scrollContainer = this.querySelector('#cart-drawer-scroll-container')
    // document.querySelector('#cart-close-button').addEventListener('click', () => this.close())

    this.overlay.addEventListener('click', () => this.close())
  }

  open() {
    document.querySelector('predictive-search')?.closeSearch({ restoreFocus: false })

    // Body
    document.documentElement.classList.add('overflow-hidden')
    document.body.classList.add('drawer-cart-is-open')

    // Container
    this.container.classList.remove('invisible')
    this.container.classList.remove('pointer-events-none')

    // Overlay
    this.overlay.classList.add('opacity-100')
    this.overlay.classList.remove('opacity-0')
    this.overlay.classList.remove('delay-200')

    // Contents
    this.scrollContainer.scrollTop = 0
    this.contents.classList.add('right-0')
    this.contents.classList.remove('-right-96')
  }

  close() {
    // Body
    document.documentElement.classList.remove('overflow-hidden')
    document.body.classList.remove('drawer-cart-is-open')

    // Container
    this.container.classList.add('invisible')
    this.container.classList.add('pointer-events-none')

    // Overlay
    this.overlay.classList.remove('opacity-60')
    this.overlay.classList.add('opacity-0')
    this.overlay.classList.add('delay-200')

    // Contents
    this.contents.classList.remove('right-0')
    this.contents.classList.add('-right-96')
  }

  renderContents(parsedState) {
    // TODO: Empty state should transition smoothly between empty state and non-empty state
    // this.querySelector('.drawer__inner').classList.contains('is-empty') &&
    //   this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);
      sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    });

    // TODO: Verify if this is working properly
    this.init()
    setTimeout(() => {
      this.open()
    },4)
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#cart-drawer-container',
      },
      {
        id: 'cart-button',
      },
    ];
  }

  setActiveElement(element) {
    this.activeElement = element;
  }

}

customElements.define('cart-drawer', CartDrawer)

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-button',
        section: 'cart-button',
        selector: '.count',
      },
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);